import type { RouteRecordRaw } from 'vue-router';

export const TUNING_ROUTER: RouteRecordRaw[] = [
  {
    path: '/tuning',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/tuning/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/movement/tuning/views/List.vue'),
        name: 'Tuning List',
        meta: {
          title: '재고 조정',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/movement/tuning/views/Create.vue'),
        name: 'Tuning Create',
        meta: {
          title: '재고 조정 등록',
        },
      },
    ],
  },
];
